import { useState, useEffect } from "react";
export function useIpLocation() {
    const [ipLocation, setIpLocation] = useState(() => {
        const cached = sessionStorage.getItem("geo_ip_location");
        return cached ? JSON.parse(cached) : null;
    });
    useEffect(() => {
        if (ipLocation)
            return;
        const handler = (event) => {
            const customEvent = event;
            setIpLocation(customEvent.detail.country);
        };
        document.body.addEventListener("theme::current::ip", handler);
        return () => document.body.removeEventListener("theme::current::ip", handler);
    }, [ipLocation]);
    return ipLocation;
}
